import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f1d580f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "cart" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  id: "totals"
}
const _hoisted_4 = { id: "subtotal" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cart Total:", -1))
const _hoisted_6 = { id: "fee" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Transaction Fee:", -1))
const _hoisted_8 = {
  key: 1,
  id: "timer"
}
const _hoisted_9 = {
  key: 2,
  class: "expired"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("em", null, "Cart has expired!")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "loader-container"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your cart is empty.", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CartProduct = _resolveComponent("CartProduct")!
  const _component_SpinnerElement = _resolveComponent("SpinnerElement")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cart.products.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart.products, (product) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "ticket",
              key: product._id
            }, [
              _createVNode(_component_CartProduct, {
                eventDate: product.eventDate,
                id: product._id,
                time: product.time,
                name: product.name,
                price: product.price,
                productQuantity: product.quantity,
                onUpdateEvent: _ctx.update
              }, null, 8, ["eventDate", "id", "time", "name", "price", "productQuantity", "onUpdateEvent"])
            ]))
          }), 128)),
          (_ctx.cart.subTotal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(" $" + _toDisplayString(_ctx.cart.subTotal.toFixed(2)), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(" $" + _toDisplayString(Number((_ctx.cart.subTotal + .30) / (1 - .029) - _ctx.cart.subTotal).toFixed(2)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isExpired && _ctx.cart.products.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createElementVNode("strong", null, [
                  _createElementVNode("em", null, "Cart expires in: " + _toDisplayString(_ctx.timer), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isExpired)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_SpinnerElement)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.cart.products.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}